import * as consts from '../constants';
import initialState from './initialState';

export default function warrantyReducer(state = initialState.warrantyState, action) {
    switch (action.type) {
        case consts.ACTONS.LOAD_WARRANTIES_SUCCESS:
            return action.pagingModel;
        case consts.ACTONS.LOAD_WARRANTIES_FAILED:
            return initialState.warrantyState;
        default:
            return state;
    }
}
